import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "t3 font-medium" }

import { computed } from 'vue'
import i18n from '@/scripts/app-configs/i18n-config'
import { STATUS_COLORS, I18N_PREFIXES, type StatusType } from './base-pill.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    type: {},
    status: {}
  },
  setup(__props: any) {

const props = __props

const color = computed(() => {
  const statusMap = STATUS_COLORS[props.type]

  return statusMap[props.status as keyof typeof statusMap]
})

const label = computed(() => i18n.t(`${I18N_PREFIXES[props.type]}.${props.status.toUpperCase()}`))

return (_ctx: any,_cache: any) => {
  const _component_sword_tag = _resolveComponent("sword-tag")!

  return (_openBlock(), _createBlock(_component_sword_tag, { color: color.value }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(label.value), 1)
    ], undefined, true),
    _: 1
  }, 8, ["color"]))
}
}

})